export var PhoneCallDirection;
(function (PhoneCallDirection) {
    PhoneCallDirection[PhoneCallDirection["SCHEDULED"] = 100] = "SCHEDULED";
    PhoneCallDirection[PhoneCallDirection["INBOUND"] = 110] = "INBOUND";
    PhoneCallDirection[PhoneCallDirection["OUTBOUND"] = 120] = "OUTBOUND";
})(PhoneCallDirection || (PhoneCallDirection = {}));
//# sourceMappingURL=phone-call-direction.enum.js.map